import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import { useNavigate } from "react-router-dom";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { FieldArray, Form, Formik } from "formik";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { useSelector } from "react-redux";
import {
  ClientInvoiceInfo,
  lineItemInvoiceInfo,
} from "../../../SchemaInfo/info";
import { ClientInvoiceSchema } from "../../../Schemas/clients/client_invoice_schema";
import CustomRadioButton from "../../../CustomComponent/custom_radio";
import { getId } from "../../../Components/Functions/word.fun";

const ViewClientInvoice = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
  const user = useSelector((store) => store?.login.user);
  const [finalAmount, setFinalAmmout] = useState(0);
  const [gstAmt, setGstAmt] = useState(0);
  const [isDropdown, setIsDropdown] = useState("");
  const [finalAmountWithGST, setFinalAmountWithGST] = useState(0);
  const [dataCn, setDataCn] = useState(ClientInvoiceInfo);

  const proformaRoles = [
    process.env.REACT_APP_ROLE_SALLE,
    process.env.REACT_APP_ROLE_SALLE_ADMIN,
    process.env.REACT_APP_ROLE_SALES_MANAGER,
  ];

  const isProformaUser = proformaRoles.includes(user?.Role);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/invoice/getInvoiceById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setDataCn(res.data);
        } else {
          Toast("error", "Error while getting Invoice!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const MarkAsFinal = () => {
    performRequest("PATCH", `/invoice/updateInvoiceStatus/${id}`)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Update Mark As Final");
          setRefresh(!refresh);
          navigate("/client-invoice");
        } else {
          Toast("error", "Error while getting Mark As Final !");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  };

  const returnClassname = (status) => {
    if (status === "completed") {
      return "badge bg-success  text-white";
    } else if (status === "draft") {
      return "badge bg-danger  text-white";
    }
  };

  const DeleteInvoice = () => {
    // console.log("Updating Invoice ID:", id);
    performRequest("DELETE", `/invoice/deleteInvoice/${id}`)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Invoice deleted successfully");
          setRefresh(!refresh);
          navigate("/client-invoice");
        } else {
          Toast("error", "Error while getting Mark As Final !");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  };

  if (loading) {
    return <LoadingPage />;
  }

  const handelSubmitNew = (values, actions) => {
    values = {
      ...values,
      generatedBy: user.Name,
      invoiceType: "credit note",
    };
    let CompData = values?.lineItems?.map((item, index) => {
      return {
        ...item,
        totalWithGst:
          item.itemQuantity * item.itemPrice -
          (item.itemQuantity * item.itemPrice * item.discount) / 100 +
          ((item.itemQuantity * item.itemPrice -
            (item.itemQuantity * item.itemPrice * item.discount) / 100) *
            item.gstRate) /
            100,
        totalWithoutGst:
          item.itemQuantity * item.itemPrice -
          (item.itemQuantity * item.itemPrice * item.discount) / 100,
      };
    });
    values = {
      ...values,
      lineItems: CompData,
      address: `${
        values?.billingAddress?.addressLine1 ||
        values?.billingAddress?.addressLine1
      }, ${values?.billingAddress?.city}, ${values?.billingAddress?.pincode}`,
      subTotal: finalAmount.toFixed(2),
      totalAmountIncGst: finalAmountWithGST.toFixed(2),
      totalGst: gstAmt.toFixed(2),
      manualInvoiceNumber: values?.manualInvoiceNumber?.toUpperCase(),
    };

    performRequest("POST", `/creditNote/createCreditNote/`, values)
      .then((res) => {
        if (res.status === 201) {
          document.getElementById("btn-close").click();
          Toast("success", "Credit Note Create Successfully!");
          navigate(`/credit-notes/view/${getId(res.data?.creditNoteNumber)}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const checkTouched = (obj) => {
    if (
      obj.deliveryDate === "" &&
      obj.gstRate === "" &&
      obj.itemPrice === "" &&
      obj.itemQuantity === "" &&
      obj.itemUnit === "" &&
      obj.notes === "" &&
      obj.particulars === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                {/* <h2 className="page-title mb-1">Invoice Management</h2> */}
                <h2 className="page-title">
                  {/* <FcFinePrint className="fs-2 me-1" /> */}
                  {isProformaUser
                    ? "Proforma Invoice Management"
                    : "Invoice Management"}
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">
                View Invoice :{" "}
                {data?.manualInvoiceNumber || data?.invoiceNumber}{" "}
              </h2>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Client Project
                  </label>
                  <div className="w-100 col">
                    {(data?.clproject || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Invoice type</label>
                  <div className="w-100 col">
                    {(data?.invoiceType || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Invoice date</label>
                  <div className="w-100 col">
                    {(data.invoiceDate || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Business name</label>
                  <div className="w-100 col">
                    {(data?.businessName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Contact person name
                  </label>
                  <div className="w-100 col">
                    {(data?.contactPersonName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Phone number</label>
                  <div className="w-100 col">
                    {(data?.phoneNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">GST number</label>
                  <div className="w-100 col">
                    {(data?.gstNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Address</label>
                  <div className="w-100 col">
                    {(data?.address || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Country of supply
                  </label>
                  <div className="w-100 col">
                    {(data?.countryOfSupply || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Place of supply
                  </label>
                  <div className="w-100 col">
                    {(data?.billingAddress?.state || "N/A").toUpperCase()}
                  </div>
                </div>
              )}

              {data && data?.billingAddress?.state !== "Maharashtra" && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Total GST</label>
                  <div className="w-100 col">{data?.totalGst || "N/A"}</div>
                </div>
              )}
              {data && data?.billingAddress?.state == "Maharashtra" && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Total CGST</label>
                  <div className="w-100 col">
                    {data?.totalGst ? roundOffCost(+data?.totalGst / 2) : "N/A"}
                  </div>
                </div>
              )}
              {data && data?.billingAddress?.state == "Maharashtra" && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Total SGST</label>
                  <div className="w-100 col">
                    {data?.totalGst ? roundOffCost(data?.totalGst / 2) : "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Total amount (inc) GST
                  </label>
                  <div className="w-100 col">
                    {data?.totalAmountIncGst
                      ? roundOffCost(+data?.totalAmountIncGst)
                      : "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Notes</label>
                  <div className="w-100 col">
                    {(data?.notes || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Status</label>
                  <div className="w-100 col">
                    <span className={returnClassname(data?.status)}>
                      {" "}
                      {(data?.status || "N/A").toUpperCase()}
                    </span>
                  </div>
                </div>
              )}
              <hr />
              <h2>Line Items</h2>
              <hr />
              {data &&
                data.lineItems?.map((lineItem, index) => {
                  return (
                    <div>
                      <h2>{++index}.</h2>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Particulars
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.particulars || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item unit
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemUnit || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item quantity
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemQuantity || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item price:
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemPrice || "N/A").toUpperCase()}
                        </div>
                      </div>
                      {data &&
                        data?.billingAddress?.state !== "Maharashtra" && (
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              IGST rate (%)
                            </label>
                            <div className="w-100 col">
                              {lineItem?.gstRate || "N/A"}
                            </div>
                          </div>
                        )}
                      {data &&
                        data?.billingAddress?.state === "Maharashtra" && (
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              CGST rate (%)
                            </label>
                            <div className="w-100 col">
                              {lineItem?.gstRate
                                ? +lineItem?.gstRate / 2
                                : "N/A"}
                            </div>
                          </div>
                        )}
                      {data &&
                        data?.billingAddress?.state === "Maharashtra" && (
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              SGST rate (%)
                            </label>
                            <div className="w-100 col">
                              {lineItem?.gstRate
                                ? +lineItem?.gstRate / 2
                                : "N/A"}
                            </div>
                          </div>
                        )}
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Discount (%)
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.discount || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">HSN</label>
                        <div className="w-100 col">
                          {lineItem?.HSN || "N/A"}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Amount (excl) gst
                        </label>
                        <div className="w-100 col">
                          {lineItem?.totalWithoutGst || "N/A"}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Amount (incl) gst
                        </label>
                        <div className="w-100 col">
                          {lineItem?.totalWithGst || "N/A"}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">Notes</label>
                        <div className="w-100 col">
                          {(lineItem?.notes || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <hr />
                    </div>
                  );
                })}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                {!isProformaUser && (
                  <button
                    className="btn mx-1 mt-2 btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#creditNote"
                  >
                    CREDIT NOTE
                  </button>
                )}
                {!isProformaUser && (
                  <div
                    className="modal fade "
                    id="creditNote"
                    tabIndex="-1"
                    role="dialog"
                    aria-hidden="true"
                  >
                    <div
                      className="modal-dialog modal-dialog-centered modal-dialog-scrollable "
                      style={{ maxWidth: "800px" }}
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Create Credit Note</h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            id="btn-close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <Formik
                            initialValues={dataCn}
                            validationSchema={ClientInvoiceSchema}
                            onSubmit={handelSubmitNew}
                          >
                            {(props) => (
                              <Form>
                                <div className="card-body">
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      Invoice type
                                    </label>
                                    <div className="col-9">
                                      <div className="d-flex gap-3">
                                        <CustomRadioButton
                                          type="radio"
                                          name="invoiceType"
                                          value="proforma invoice"
                                        />
                                        <label>Proforma Invoice</label>
                                        <CustomRadioButton
                                          type="radio"
                                          name="invoiceType"
                                          value="invoice"
                                        />
                                        <label>Invoice</label>
                                      </div>
                                      {props.touched.invoiceType &&
                                        props.errors.invoiceType && (
                                          <p className="text-danger">
                                            {props.errors.invoiceType}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      Invoice date
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="invoiceDate"
                                        disabled={data?.status === "completed"}
                                        type="date"
                                      />
                                      {props.touched.invoiceDate &&
                                        props.errors.invoiceDate && (
                                          <p className="text-danger">
                                            {props.errors.invoiceDate}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      Client project
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="clproject"
                                        type="text"
                                      />
                                      {props.touched.clId &&
                                        props.errors.clId && (
                                          <p className="text-danger">
                                            {props.errors.clId}
                                          </p>
                                        )}
                                      {props.touched.clproject &&
                                        props.errors.clproject && (
                                          <p className="text-danger">
                                            {props.errors.clproject}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label required col-3">
                                      Business name
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="businessName"
                                        type="text"
                                        disabled={data?.status === "completed"}
                                      />
                                      {props.touched.businessName &&
                                        props.errors.businessName && (
                                          <p className="text-danger">
                                            {props.errors.businessName}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label required col-3">
                                      Contact person name
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="contactPersonName"
                                        type="text"
                                        disabled={data?.status === "completed"}
                                      />
                                      {props.touched.contactPersonName &&
                                        props.errors.contactPersonName && (
                                          <p className="text-danger">
                                            {props.errors.contactPersonName}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label  col-3">
                                      Phone number
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="phoneNumber"
                                        type="text"
                                        disabled={data?.status === "completed"}
                                      />
                                      {props.touched.phoneNumber &&
                                        props.errors.phoneNumber && (
                                          <p className="text-danger">
                                            {props.errors.phoneNumber}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      GST number
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="gstNumber"
                                        type="text"
                                        disabled={data?.status === "completed"}
                                      />
                                      {props.touched.gstNumber &&
                                        props.errors.gstNumber && (
                                          <p className="text-danger">
                                            {props.errors.gstNumber}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <hr className="my-2" />
                                  <h3>Shipping Address :</h3>
                                  <hr className="my-2" />
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      Address
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="shippingAddress.addressLine1"
                                        type="text"
                                        placeholder="Address line 1"
                                      />
                                      <div className="mt-2">
                                        <CustomInput
                                          name="shippingAddress.addressLine2"
                                          type="text"
                                          placeholder="Address line 2"
                                        />
                                      </div>
                                      {props.touched.shippingAddress
                                        ?.addressLine1 &&
                                        props.errors.shippingAddress
                                          ?.addressLine1 && (
                                          <p className="text-danger">
                                            {
                                              props.errors.shippingAddress
                                                ?.addressLine1
                                            }
                                          </p>
                                        )}
                                      {props.touched.shippingAddress
                                        ?.addressLine2 &&
                                        props.errors.shippingAddress
                                          ?.addressLine2 && (
                                          <p className="text-danger">
                                            {
                                              props.errors.shippingAddress
                                                ?.addressLine2
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      City
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="shippingAddress.city"
                                        type="text"
                                      />
                                      {props.touched.shippingAddress?.city &&
                                        props.errors.shippingAddress?.city && (
                                          <p className="text-danger">
                                            {props.errors.shippingAddress?.city}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      Pincode
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="shippingAddress.pincode"
                                        type="text"
                                      />
                                      {props.touched.shippingAddress?.pincode &&
                                        props.errors.shippingAddress
                                          ?.pincode && (
                                          <p className="text-danger">
                                            {
                                              props.errors.shippingAddress
                                                ?.pincode
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      State
                                    </label>
                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name="shippingAddress.state"
                                      >
                                        <option value="">Select State</option>
                                        <option value="Andhra Pradesh">
                                          Andhra Pradesh
                                        </option>
                                        <option value="Arunachal Pradesh">
                                          Arunachal Pradesh
                                        </option>
                                        <option value="Assam">Assam</option>
                                        <option value="Bihar">Bihar</option>
                                        <option value="Chhattisgarh">
                                          Chhattisgarh
                                        </option>
                                        <option value="Goa">Goa</option>
                                        <option value="Gujarat">Gujarat</option>
                                        <option value="Haryana">Haryana</option>
                                        <option value="Himachal Pradesh">
                                          Himachal Pradesh
                                        </option>
                                        <option value="Jharkhand">
                                          Jharkhand
                                        </option>
                                        <option value="Karnataka">
                                          Karnataka
                                        </option>
                                        <option value="Kerala">Kerala</option>
                                        <option value="Madhya Pradesh">
                                          Madhya Pradesh
                                        </option>
                                        <option value="Maharashtra">
                                          Maharashtra
                                        </option>
                                        <option value="Manipur">Manipur</option>
                                        <option value="Meghalaya">
                                          Meghalaya
                                        </option>
                                        <option value="Mizoram">Mizoram</option>
                                        <option value="Nagaland">
                                          Nagaland
                                        </option>
                                        <option value="Odisha">Odisha</option>
                                        <option value="Punjab">Punjab</option>
                                        <option value="Rajasthan">
                                          Rajasthan
                                        </option>
                                        <option value="Sikkim">Sikkim</option>
                                        <option value="Tamil Nadu">
                                          Tamil Nadu
                                        </option>
                                        <option value="Telangana">
                                          Telangana
                                        </option>
                                        <option value="Tripura">Tripura</option>
                                        <option value="Uttar Pradesh">
                                          Uttar Pradesh
                                        </option>
                                        <option value="Uttarakhand">
                                          Uttarakhand
                                        </option>
                                        <option value="West Bengal">
                                          West Bengal
                                        </option>
                                        <option value="Andaman and Nicobar Islands">
                                          Andaman and Nicobar Islands
                                        </option>
                                        <option value="Chandigarh">
                                          Chandigarh
                                        </option>
                                        <option value="Dadra and Nagar Haveli and Daman and Diu">
                                          Dadra and Nagar Haveli and Daman and
                                          Diu
                                        </option>
                                        <option value="Lakshadweep">
                                          Lakshadweep
                                        </option>
                                        <option value="Delhi">Delhi</option>
                                        <option value="Puducherry">
                                          Puducherry
                                        </option>
                                      </CustomSelect>

                                      {props.touched.shippingAddress?.state &&
                                        props.errors.shippingAddress?.state && (
                                          <p className="text-danger">
                                            {
                                              props.errors.shippingAddress
                                                ?.state
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      Country
                                    </label>
                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name="shippingAddress.country"
                                      >
                                        <option value="">Select Country</option>
                                        <option value="India">India</option>
                                      </CustomSelect>

                                      {props.touched.shippingAddress?.country &&
                                        props.errors.shippingAddress
                                          ?.country && (
                                          <p className="text-danger">
                                            {
                                              props.errors.shippingAddress
                                                ?.country
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <hr className="my-2" />
                                  <div className="row mb-0">
                                    <div className="col-3">
                                      <label className="form-label fs-3 required">
                                        Billing Address :
                                      </label>
                                    </div>
                                    <div className="col-9 ">
                                      <div className="d-flex gap-3">
                                        <input
                                          className="orm-check-input"
                                          style={{
                                            width: "21px",
                                            height: `21px`,
                                          }}
                                          type="checkbox"
                                          onChange={(e) => {
                                            if (e.target.checked) {
                                              props.setFieldValue(
                                                "billingAddress.addressLine1",
                                                props.values.shippingAddress
                                                  .addressLine1
                                              );
                                              props.setFieldValue(
                                                "billingAddress.addressLine2",
                                                props.values.shippingAddress
                                                  .addressLine2
                                              );
                                              props.setFieldValue(
                                                "billingAddress.city",
                                                props.values.shippingAddress
                                                  .city
                                              );
                                              props.setFieldValue(
                                                "billingAddress.pincode",
                                                props.values.shippingAddress
                                                  .pincode
                                              );
                                              props.setFieldValue(
                                                "billingAddress.state",
                                                props.values.shippingAddress
                                                  .state
                                              );
                                              props.setFieldValue(
                                                "billingAddress.country",
                                                props.values.shippingAddress
                                                  .country
                                              );
                                            } else {
                                              props.setFieldValue(
                                                "billingAddress.addressLine1",
                                                ""
                                              );
                                              props.setFieldValue(
                                                "billingAddress.addressLine2",
                                                ""
                                              );
                                              props.setFieldValue(
                                                "billingAddress.city",
                                                ""
                                              );
                                              props.setFieldValue(
                                                "billingAddress.pincode",
                                                ""
                                              );
                                              props.setFieldValue(
                                                "billingAddress.state",
                                                ""
                                              );
                                              props.setFieldValue(
                                                "billingAddress.country",
                                                ""
                                              );
                                            }
                                          }}
                                        />
                                        <label className="form-label">
                                          Same as shipping address
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <hr className="mt-0 mb-2" />
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      Address
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="billingAddress.addressLine1"
                                        type="text"
                                        placeholder="Address line 1"
                                      />
                                      <div className="mt-2">
                                        <CustomInput
                                          name="billingAddress.addressLine2"
                                          type="text"
                                          placeholder="Address line 2"
                                        />
                                      </div>
                                      {props.touched.billingAddress
                                        ?.addressLine1 &&
                                        props.errors.billingAddress
                                          ?.addressLine1 && (
                                          <p className="text-danger">
                                            {
                                              props.errors.billingAddress
                                                ?.addressLine1
                                            }
                                          </p>
                                        )}
                                      {props.touched.billingAddress
                                        ?.addressLine2 &&
                                        props.errors.billingAddress
                                          ?.addressLine2 && (
                                          <p className="text-danger">
                                            {
                                              props.errors.billingAddress
                                                ?.addressLine2
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      City
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="billingAddress.city"
                                        type="text"
                                      />
                                      {props.touched.billingAddress?.city &&
                                        props.errors.billingAddress?.city && (
                                          <p className="text-danger">
                                            {props.errors.billingAddress?.city}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      Pincode
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="billingAddress.pincode"
                                        type="text"
                                      />
                                      {props.touched.billingAddress?.pincode &&
                                        props.errors.billingAddress
                                          ?.pincode && (
                                          <p className="text-danger">
                                            {
                                              props.errors.billingAddress
                                                ?.pincode
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      State
                                    </label>
                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name="billingAddress.state"
                                      >
                                        <option value="">Select State</option>
                                        <option value="Andhra Pradesh">
                                          Andhra Pradesh
                                        </option>
                                        <option value="Arunachal Pradesh">
                                          Arunachal Pradesh
                                        </option>
                                        <option value="Assam">Assam</option>
                                        <option value="Bihar">Bihar</option>
                                        <option value="Chhattisgarh">
                                          Chhattisgarh
                                        </option>
                                        <option value="Goa">Goa</option>
                                        <option value="Gujarat">Gujarat</option>
                                        <option value="Haryana">Haryana</option>
                                        <option value="Himachal Pradesh">
                                          Himachal Pradesh
                                        </option>
                                        <option value="Jharkhand">
                                          Jharkhand
                                        </option>
                                        <option value="Karnataka">
                                          Karnataka
                                        </option>
                                        <option value="Kerala">Kerala</option>
                                        <option value="Madhya Pradesh">
                                          Madhya Pradesh
                                        </option>
                                        <option value="Maharashtra">
                                          Maharashtra
                                        </option>
                                        <option value="Manipur">Manipur</option>
                                        <option value="Meghalaya">
                                          Meghalaya
                                        </option>
                                        <option value="Mizoram">Mizoram</option>
                                        <option value="Nagaland">
                                          Nagaland
                                        </option>
                                        <option value="Odisha">Odisha</option>
                                        <option value="Punjab">Punjab</option>
                                        <option value="Rajasthan">
                                          Rajasthan
                                        </option>
                                        <option value="Sikkim">Sikkim</option>
                                        <option value="Tamil Nadu">
                                          Tamil Nadu
                                        </option>
                                        <option value="Telangana">
                                          Telangana
                                        </option>
                                        <option value="Tripura">Tripura</option>
                                        <option value="Uttar Pradesh">
                                          Uttar Pradesh
                                        </option>
                                        <option value="Uttarakhand">
                                          Uttarakhand
                                        </option>
                                        <option value="West Bengal">
                                          West Bengal
                                        </option>
                                        <option value="Andaman and Nicobar Islands">
                                          Andaman and Nicobar Islands
                                        </option>
                                        <option value="Chandigarh">
                                          Chandigarh
                                        </option>
                                        <option value="Dadra and Nagar Haveli and Daman and Diu">
                                          Dadra and Nagar Haveli and Daman and
                                          Diu
                                        </option>
                                        <option value="Lakshadweep">
                                          Lakshadweep
                                        </option>
                                        <option value="Delhi">Delhi</option>
                                        <option value="Puducherry">
                                          Puducherry
                                        </option>
                                      </CustomSelect>

                                      {props.touched.billingAddress?.state &&
                                        props.errors.billingAddress?.state && (
                                          <p className="text-danger">
                                            {props.errors.billingAddress?.state}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      Country
                                    </label>
                                    <div className="w-100 col">
                                      <CustomSelect
                                        type="text"
                                        name="billingAddress.country"
                                      >
                                        <option value="">Select Country</option>
                                        <option value="India">India</option>
                                      </CustomSelect>

                                      {props.touched.billingAddress?.country &&
                                        props.errors.billingAddress
                                          ?.country && (
                                          <p className="text-danger">
                                            {
                                              props.errors.billingAddress
                                                ?.country
                                            }
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <hr className="my-2" />
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      Invoice Number
                                    </label>
                                    <div className="w-100 col">
                                      <CustomInput
                                        name="manualInvoiceNumber"
                                        type="text"
                                        placeholder="auto generate if not added"
                                      />
                                      {props.touched.manualInvoiceNumber &&
                                        props.errors.manualInvoiceNumber && (
                                          <p className="text-danger">
                                            {props.errors.manualInvoiceNumber}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="w-25 form-label col-3">
                                      Notes
                                    </label>
                                    <div className="w-100 col">
                                      <CustomTextArea
                                        name="notes"
                                        type="text"
                                        disabled={data?.status === "completed"}
                                      />
                                      {props.touched.notes &&
                                        props.errors.notes && (
                                          <p className="text-danger">
                                            {props.errors.notes}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  <hr />
                                  <h3>Line Items :</h3>
                                  <hr />
                                  <FieldArray name="lineItems">
                                    {({ push, remove }) => (
                                      <div>
                                        {props.values.lineItems.map(
                                          (lineItem, index) => {
                                            return (
                                              <div key={index}>
                                                <div className="row g-3 align-items-center">
                                                  <div className="col-md">
                                                    <label className=" form-label">
                                                      Particulars:
                                                    </label>
                                                    <div className="w-100 col">
                                                      <CustomInput
                                                        type="text"
                                                        name={`lineItems[${index}].particulars`}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="col-md">
                                                    <label className=" form-label ">
                                                      Units:
                                                    </label>

                                                    <div className="w-100 col">
                                                      <CustomSelect
                                                        type="text"
                                                        name={`lineItems[${index}].itemUnit`}
                                                      >
                                                        <option value="">
                                                          Select
                                                        </option>
                                                        <option value="nos">
                                                          Nos
                                                        </option>
                                                        <option value="kg">
                                                          Kg
                                                        </option>
                                                        <option value="grams">
                                                          Grams
                                                        </option>
                                                        <option value="ltr">
                                                          Litter
                                                        </option>
                                                        <option value="ml">
                                                          ML
                                                        </option>
                                                        <option value="packs">
                                                          Packs
                                                        </option>
                                                        <option value="sqm">
                                                          SqM
                                                        </option>
                                                        <option value="sqft">
                                                          SqFt
                                                        </option>
                                                      </CustomSelect>
                                                    </div>
                                                  </div>
                                                  <div className="col-md">
                                                    <label className=" form-label ">
                                                      Quantity
                                                    </label>
                                                    <div className="w-100 col">
                                                      <CustomInput
                                                        type={"text"}
                                                        name={`lineItems[${index}].itemQuantity`}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="col-md">
                                                    <label className=" form-label ">
                                                      Item price
                                                    </label>
                                                    <div className="w-100 col">
                                                      <CustomInput
                                                        type="text"
                                                        name={`lineItems[${index}].itemPrice`}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="col-md">
                                                    <label className=" form-label ">
                                                      GST (%)
                                                    </label>
                                                    <div className="w-100 col">
                                                      <CustomSelect
                                                        type="text"
                                                        name={`lineItems[${index}].gstRate`}
                                                      >
                                                        <option value="">
                                                          Select
                                                        </option>
                                                        {/* {props.billingAddress.state} */}
                                                        <option value="0">
                                                          0 %
                                                        </option>
                                                        <option value="5">
                                                          5%
                                                        </option>
                                                        <option value="12">
                                                          12%
                                                        </option>
                                                        <option value="18">
                                                          18%
                                                        </option>
                                                        <option value="28">
                                                          28%
                                                        </option>
                                                        <option value="100">
                                                          100%
                                                        </option>
                                                      </CustomSelect>
                                                    </div>
                                                  </div>
                                                  {/* <div className="col-md">
                                                                             <label className=" form-label ">
                                                                               Discount
                                                                             </label>
                                                                             <div className="w-100 col">
                                                                               <CustomInput
                                                                                 type={"text"}
                                                                                 name={`lineItems[${index}].discount`}
                                                                               />
                                                                             </div>
                                                                           </div> */}
                                                </div>
                                                <div className="row g-3 align-items-center">
                                                  <div className="col-md">
                                                    <label className=" form-label ">
                                                      HSN
                                                    </label>
                                                    <div className="w-100 col">
                                                      <CustomInput
                                                        type={"text"}
                                                        name={`lineItems[${index}].HSN`}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="col-md">
                                                    <label className=" form-label ">
                                                      Amount (excl GST)
                                                    </label>
                                                    <div className="w-100 col">
                                                      {roundOffCost(
                                                        lineItem.itemQuantity *
                                                          lineItem.itemPrice -
                                                          (lineItem.itemQuantity *
                                                            lineItem.itemPrice *
                                                            lineItem.discount) /
                                                            100
                                                      )}
                                                    </div>
                                                  </div>
                                                  {/* add po */}
                                                  <div className="col-md">
                                                    <label className=" form-label ">
                                                      Amount (Inc GST):
                                                    </label>
                                                    <div className="w-100 col">
                                                      {roundOffCost(
                                                        lineItem.itemQuantity *
                                                          lineItem.itemPrice -
                                                          (lineItem.itemQuantity *
                                                            lineItem.itemPrice *
                                                            lineItem.discount) /
                                                            100 +
                                                          ((lineItem.itemQuantity *
                                                            lineItem.itemPrice -
                                                            (lineItem.itemQuantity *
                                                              lineItem.itemPrice *
                                                              lineItem.discount) /
                                                              100) *
                                                            lineItem.gstRate) /
                                                            100
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="col-md">
                                                    <button
                                                      className="col-3 btn btn-primary"
                                                      style={{
                                                        width: "70px",
                                                        height: "30px",
                                                      }}
                                                      type="button"
                                                      onClick={() =>
                                                        remove(index)
                                                      }
                                                    >
                                                      Remove
                                                    </button>
                                                  </div>
                                                </div>
                                                <hr />
                                              </div>
                                            );
                                          }
                                        )}

                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          disabled={
                                            data?.status === "completed"
                                          }
                                          onClick={() => {
                                            if (
                                              props.values.lineItems.length ===
                                              0
                                            ) {
                                              push(lineItemInvoiceInfo);
                                            } else if (
                                              props.values.lineItems.length >
                                                0 &&
                                              checkTouched(
                                                props.values.lineItems[
                                                  props.values.lineItems
                                                    .length - 1
                                                ]
                                              )
                                            ) {
                                              push(lineItemInvoiceInfo);
                                            } else {
                                              Toast(
                                                "error",
                                                "Please fill at least one line item field."
                                              );
                                            }
                                          }}
                                        >
                                          Add Line Item
                                        </button>
                                      </div>
                                    )}
                                  </FieldArray>
                                  <hr />
                                  <h3> Total :</h3>
                                  <hr />
                                  {(() => {
                                    const totalSubTotal =
                                      props.values?.lineItems?.reduce(
                                        (acc, lineItem) => {
                                          const subTotal =
                                            lineItem.itemQuantity *
                                              lineItem.itemPrice -
                                            (lineItem.itemQuantity *
                                              lineItem.itemPrice *
                                              lineItem.discount) /
                                              100;
                                          return acc + subTotal;
                                        },
                                        0
                                      );

                                    const totalGST =
                                      props.values.lineItems.reduce(
                                        (acc, lineItem) => {
                                          const subTotal =
                                            lineItem.itemQuantity *
                                              lineItem.itemPrice -
                                            (lineItem.itemQuantity *
                                              lineItem.itemPrice *
                                              lineItem.discount) /
                                              100;
                                          const gstAmount =
                                            subTotal * (lineItem.gstRate / 100);
                                          return acc + gstAmount;
                                        },
                                        0
                                      );

                                    const totalPostGST =
                                      totalSubTotal + totalGST;
                                    let sgstAmt = 0;
                                    let cgstAmt = 0;
                                    if (
                                      props.values?.billingAddress?.state ===
                                      "Maharashtra"
                                    ) {
                                      sgstAmt = cgstAmt = totalGST / 2;
                                    } else {
                                    }
                                    if (totalPostGST) {
                                      setFinalAmmout(totalSubTotal);
                                      setGstAmt(totalGST);
                                      setFinalAmountWithGST(totalPostGST);
                                    }
                                    return (
                                      <div>
                                        <div className="mb-3 row">
                                          <label className="w-25 form-label col-3">
                                            Sub-total (Excl GST):
                                          </label>
                                          <div className="w-100 col">
                                            {roundOffCost(totalSubTotal)}
                                          </div>
                                        </div>
                                        {props.values?.billingAddress?.state !==
                                          "Maharashtra" && (
                                          <div className="mb-3 row">
                                            <label className="w-25 form-label col-3">
                                              Total IGST:
                                            </label>
                                            <div className="w-100 col">
                                              {" "}
                                              {roundOffCost(totalGST)}
                                            </div>
                                          </div>
                                        )}
                                        {props.values?.billingAddress?.state ===
                                          "Maharashtra" && (
                                          <div className="mb-3 row">
                                            <label className="w-25 form-label col-3">
                                              Total CGST:
                                            </label>
                                            <div className="w-100 col">
                                              {" "}
                                              {roundOffCost(cgstAmt)}
                                            </div>
                                          </div>
                                        )}
                                        {props.values?.billingAddress?.state ===
                                          "Maharashtra" && (
                                          <div className="mb-3 row">
                                            <label className="w-25 form-label col-3">
                                              Total SGST:
                                            </label>
                                            <div className="w-100 col">
                                              {" "}
                                              {roundOffCost(sgstAmt)}
                                            </div>
                                          </div>
                                        )}
                                        <div className="mb-3 row">
                                          <label className="w-25 form-label col-3">
                                            Total (Incl GST):
                                          </label>
                                          <div className="w-100 col">
                                            {roundOffCost(totalPostGST)}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })()}
                                </div>

                                <div className="card-footer">
                                  <div className="btn-list justify-content-end">
                                    <FormSubmitButton buttonText="Save Credit Note" />
                                    <SimpleButton
                                      buttonText="Cancel"
                                      type="secondary"
                                    />
                                  </div>
                                </div>
                              </Form>
                            )}
                          </Formik>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {!isProformaUser && (
                  <button
                    className="btn mx-1 mt-2 btn-green"
                    disabled={data?.status === "completed"}
                    onClick={MarkAsFinal}
                  >
                    MARK AS FINAL
                  </button>
                )}

                {(user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  user.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                  <button
                    className="btn mx-1 mt-2 btn-red"
                    onClick={DeleteInvoice}
                  >
                    DELETE INVOICE
                  </button>
                )}
                <SimpleButton
                  buttonText={"generate pdf"}
                  href={`/client-invoice/preview/${id}`}
                />
                <SimpleButton
                  buttonText="Duplicate Invoice"
                  href={`/client-invoice/new?duplicate=${id}`}
                />
                <SimpleButton
                  buttonText="Edit Invoice"
                  href={`/client-invoice/edit/${id}`}
                />

                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewClientInvoice;
